import { createFileRoute } from "@tanstack/react-router";
import { getSystemsListQueryOptions } from "@/api/wai/wai3Api";
import Page from "@/components/Page";
import GrunndataContainer from "@/components/System/GrunndataContainer";

function SystemGrunndata() {
  return (
    <Page contentPadding maxWidth="xl">
      <GrunndataContainer />
    </Page>
  );
}

export const Route = createFileRoute("/_auth/grunndata")({
  component: SystemGrunndata,
  beforeLoad: () => {
    return {
      getTitle: () => "Grunndata",
    };
  },
  loader: ({ context: { queryClient } }) => {
    void queryClient.query(getSystemsListQueryOptions());
  },
});
